import {API_URL} from '../../../../resources/api';

export const rankURL : string = `${API_URL}dashboard/bar/rank`;
export const winLosesURL : string = `${API_URL}dashboard/bar/winloses`;